import React from 'react';
import './InfoGroupBookingPage.scss';
import Spinner from 'Components/Shared/Spinner/Spinner';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';

interface IProps {
  isFetching: boolean;
  content: Julius.Website.GroupPageViewModel;
}

const InfoGroupBookingPage: React.SFC<IProps> = ({
  isFetching,
  content,
}) => {

  if (isFetching) {
    return <Spinner height='lg' />;
  }

  if (!content) {
    return null;
  }

  return (
    <WrapperLayout style='info-group-booking-page' padding='xl'>
      <div className='title'>{ content.title }</div>
      <div dangerouslySetInnerHTML={ { __html: content.text } } />
    </WrapperLayout>
  );
};

export default InfoGroupBookingPage;


// WEBPACK FOOTER //
// ./src/pages/InfoGroupBookingPage/InfoGroupBookingsPage.tsx